import axios from "axios";

import { concat, pick } from "ramda";
import { CAMPAIGNS_V2_API } from "../api";

// Redux Prefix
const prefix = concat("CAMPAIGN_SELF_SIGNUP:");

// Actions

const SUBMIT_CAMPAIGN_TO_API = prefix("SUBMIT_CAMPAIGN_TO_API");
const SUBMIT_CAMPAIGN_CREATE_SUCCESS = prefix("SUBMIT_CAMPAIGN_SUCCESS");
const SUBMIT_CAMPAIGN_CREATE_ERROR = prefix("SUBMIT_CAMPAIGN_CREATE_ERROR");

const OPEN_MODAL = prefix("OPEN_MODAL");
const CLOSE_MODAL = prefix("CLOSE_MODAL");
const HANDLE_BACK = prefix("HANDLE_BACK");

const PROCEED_CAMPAIGN_CREATE_MEDIA = prefix("PROCEED_CAMPAIGN_CREATE_MEDIA");
const PROCEED_CAMPAIGN_CREATE_CONFIRMATION = prefix(
  "PROCEED_CAMPAIGN_CREATE_CONFIRMATION",
);
const PROCEED_THANKYOU = prefix("PROCEED_THANKYOU");

const SET_CAMPAIGN_CREATE_REGISTRATION_VALUES = prefix(
  "SET_CAMPAIGN_CREATE_REGISTRATION_VALUES",
);
const SET_CAMPAIGN_CREATE_MEDIA_VALUES = prefix("SET_CAMPAIGN_CREATE_MEDIA_VALUES");

const SET_LOADING_DONE = prefix("SET_LOADING_DONE");
const SET_LOADING = prefix("SET_LOADING");

const initialFormValues = [
  "currentFormObjectCampaignRegistration",
  "currentFormObjectCampaignMedia",
  "campaignCreateError",
];

const INITIAL_STATE = {
  data: {},
  sectionId: "",
  donationError: null,
  loading: false,
  selectedModal: "",
  modalOpen: false,
  currentStep: "",
  currentFormObjectCampaignRegistration: { startDate: new Date(), isOngoing: true },
  currentFormObjectCampaignMedia: {},
  campaignCreateError: "",
};

// Action Creators

export const setLoading = () => ({
  type: SET_LOADING,
});

export const setLoadingDone = () => ({
  type: SET_LOADING_DONE,
});

export const submittingCampaignCreate = () => ({
  type: SUBMIT_CAMPAIGN_TO_API,
});

export const submitCampaignCreateSuccess = ({ data: { campaign } }) => ({
  type: SUBMIT_CAMPAIGN_CREATE_SUCCESS,
  payload: { campaign },
});

export const submitCampaignCreateError = (error) => ({
  type: SUBMIT_CAMPAIGN_CREATE_ERROR,
  payload: { error },
});

export const proceedToCampaignMediaStep = () => ({
  type: PROCEED_CAMPAIGN_CREATE_MEDIA,
});

export const proceedToCampaignConfirmationStep = () => ({
  type: PROCEED_CAMPAIGN_CREATE_CONFIRMATION,
});

export const proceedToThankyouStep = () => ({
  type: PROCEED_THANKYOU,
});

export const setCampaignCreateRegistrationValues = (values) => ({
  type: SET_CAMPAIGN_CREATE_REGISTRATION_VALUES,
  payload: {
    values,
  },
});

export const setCampaignCreateMediaValues = (values) => ({
  type: SET_CAMPAIGN_CREATE_MEDIA_VALUES,
  payload: {
    values,
  },
});

export const openModal = (selectedModal) => ({
  type: OPEN_MODAL,
  payload: {
    selectedModal,
  },
});

export const closeModal = () => ({
  type: CLOSE_MODAL,
});

export const handleBackButton = (step) => ({
  type: HANDLE_BACK,
  payload: {
    step,
  },
});

export const submitCampaignCreate = (formData, entityId) => {
  return async (dispatch) => {
    const config = {
      headers: { "content-type": "multipart/form-data", "ENTITY-ID": entityId },
    };
    dispatch(submittingCampaignCreate());
    dispatch(setLoading());
    axios
      .post(CAMPAIGNS_V2_API, formData, config)
      .then((response) => {
        dispatch(proceedToThankyouStep());
        dispatch(submitCampaignCreateSuccess(response));
      })
      .catch((error) => {
        dispatch(submitCampaignCreateError(error.response.data.errors));
        dispatch(setLoadingDone());
      });
  };
};

// Reducer
export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SET_LOADING_DONE:
      return {
        ...state,
        loading: false,
      };
    case HANDLE_BACK:
      return {
        ...state,
        currentStep: action.payload.step,
        campaignCreateError: "",
      };
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true,
        selectedModal: action.payload.selectedModal,
        currentStep: "campaignCreateRegistrationStep",
      };
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false,
        ...pick(initialFormValues, INITIAL_STATE),
      };
    case PROCEED_CAMPAIGN_CREATE_MEDIA:
      return {
        ...state,
        currentStep: "campaignCreateMediaStep",
      };
    case PROCEED_CAMPAIGN_CREATE_CONFIRMATION:
      return {
        ...state,
        currentStep: "campaignCreateConfirmationStep",
      };
    case PROCEED_THANKYOU:
      return {
        ...state,
        ...pick(initialFormValues, INITIAL_STATE),
        currentStep: "ThankyouStep",
      };
    case SET_CAMPAIGN_CREATE_REGISTRATION_VALUES:
      return {
        ...state,
        currentFormObjectCampaignRegistration: action.payload.values,
      };
    case SET_CAMPAIGN_CREATE_MEDIA_VALUES:
      return {
        ...state,
        currentFormObjectCampaignMedia: action.payload.values,
      };
    case SUBMIT_CAMPAIGN_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SUBMIT_CAMPAIGN_CREATE_ERROR:
      return {
        ...state,
        loading: false,
        campaignCreateError: action.payload.error,
      };
    default:
      return state;
  }
}
